"use client";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";

type HeroTextAnimationsProps = {
	txts: string[];
};

export default function HeroTextAnimations({ txts }: HeroTextAnimationsProps) {
	return (
		<span className="inline-block h-[3.188rem] overflow-hidden sm:h-[3.875rem]">
			<Swiper
				direction="vertical"
				slidesPerView={1}
				loop={true}
				autoplay={{
					delay: 1000,
					disableOnInteraction: false,
				}}
				modules={[Autoplay]}
				className="h-full"
				style={{ overflow: "hidden" }}
			>
				{txts.map((txt, index) => (
					<SwiperSlide key={index} className="inline-flex !h-full items-center">
						<div className="border-brown-middle inline-block rounded-[2.593rem] border-[0.203rem] p-[0.7rem]">
							<p className="text-rotation-mob sm:text-rotation-desk text-brown-middle whitespace-nowrap">{txt}</p>
						</div>
					</SwiperSlide>
				))}
			</Swiper>
		</span>
	);
}
